import script from "./institutionList.vue?vue&type=script&setup=true&lang=js"
export * from "./institutionList.vue?vue&type=script&setup=true&lang=js"

import "./institutionList.vue?vue&type=style&index=0&id=05a5088c&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-05a5088c"]])

export default __exports__